import { useEffect, useState } from 'react';
import { Router } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import { useLocation } from 'react-use';
import history from './store/utils/history';
import AppRoutes from './AppRoutes';
import useRefreshHook from './util/hooks/useRefreshHook';
import config from './config';
import './i18n';
import { GlobalStyle } from './assets/styles/base';
import useInitHook from './util/hooks/useInitHook';
import RefreshModal from './components/Modals/RefreshModal';
import { PAGES } from './constants/pages';
import ScrollToTopRouter from './components/ScrollToTopRouter';

const App = () => {
  const [sessionAlert, setSessionAlert] = useState(false);
  useRefreshHook(setSessionAlert, sessionAlert);

  const location = useLocation();

  const tagManagerArgs = {
    gtmId: config.gtm.gtmId,
  };

  useInitHook(history);

  useEffect(() => {
    if (location.pathname === PAGES.PREPARE_REGISTRATION) {
      return;
    }
    TagManager.initialize(tagManagerArgs);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <GlobalStyle />
      <Router history={history}>
        <ScrollToTopRouter />
        <AppRoutes />
      </Router>
      <RefreshModal isOpen={sessionAlert} close={setSessionAlert} />
    </>
  );
};

export default App;
